var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAviaoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 765,
    viewBox: "0 0 578 765",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_2363)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_2363",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 147,
    width: 667,
    height: 548
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0228 350.492L592.181 694.019L722.226 491.051L186.069 147.524L56.0228 350.492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_2363)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0227 350.493L214.422 397.196L189.525 367.482L56.0227 350.493Z",
    fill: "#3F53D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.526 367.481L196.022 338.006L56.0234 350.492L189.526 367.481Z",
    fill: "#D3DAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.971 364.655L56.023 350.492L141.421 323.584L187.971 364.655Z",
    fill: "#3F53D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.272 493.112C663.871 448.562 592.892 420.212 522.096 426.73C490.844 429.588 458.248 440.412 438.143 464.699C430.112 474.427 424.267 488.039 429.56 499.472C432.473 505 436.947 509.55 442.426 512.554C450.791 517.61 460.232 520.617 469.98 521.331C479.727 522.046 489.506 520.447 498.52 516.665C507.533 512.883 515.525 507.025 521.843 499.57C528.163 492.113 532.631 483.269 534.885 473.758C539.412 454.497 534.325 433.815 524.147 416.897C513.966 399.979 498.968 386.349 482.946 374.775C404.5 317.976 294.495 308.394 207.259 350.468",
    stroke: "black",
    strokeWidth: 1.32811,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.75 3.75"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_2363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 589.554,
    height: 510.153,
    fill: "white",
    transform: "translate(290.936 764.52) rotate(-119.57)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviaoBg);
export default __webpack_public_path__ + "static/media/aviao-bg.c166644876bc5d4d437797a3cf4b4f79.svg";
export { ForwardRef as ReactComponent };